import { Decoder, array, field, string, succeed } from 'jsonous';
import { StringOption } from '../Options/Types';

const stringOptionDecoder: Decoder<StringOption> = succeed({})
  .assign('value', field('value', string))
  .assign('label', field('content', string));

export const stringOptionsContentDecoder: Decoder<StringOption[]> = array(stringOptionDecoder);
